import { useWatch } from 'react-hook-form'
import { AppointmentFormData } from '../../types'
import { isAnyResourceId } from '../../util'

const useIsAnyResource = () => {
  const [specialistId] = useWatch<AppointmentFormData>({ name: ['specialist_id'] })

  return isAnyResourceId(specialistId as string)
}

export { useIsAnyResource }
